import React from "react";
import styles from "./index.module.scss";
import Timer from "../../../timer";
// import ReleaseBtn from "../../releaseButton";
import { FlipperVaultCardProps } from "../../index";

interface CheckedOutByMeProps {
  flipperData: FlipperVaultCardProps;
  setIsExpired: (isExpired: boolean) => void;
  // type?: string;
  // showReleaseBtn?: boolean;
  setShowReleaseBtn?: any;
}

export default function CheckedOutByMe({
  flipperData,
  setIsExpired,
  // type,
  // showReleaseBtn,
  setShowReleaseBtn
}: CheckedOutByMeProps) {
  // const lastCheckout =
  //   flipperData?.checkouts[flipperData?.checkouts?.length - 1];
  return (
    <div className={styles.releaseBtnWrap}>
      <Timer
        createdAt={
          flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]?.createdAt
        }
        ShowTitle={false}
        setShowReleaseBtn={setShowReleaseBtn}
        textColor={"Black"}
        time={
          flipperData?.checkouts[flipperData?.checkouts?.length - 1]?.expirtyAt
        }
        acctId={flipperData?.acctId}
        onExpire={() => setIsExpired(true)}
      />
      {/* {showReleaseBtn &&
        lastCheckout?.bidCount === 0 && (
          <ReleaseBtn
            id={flipperData?.checkouts[flipperData?.checkouts?.length - 1]?.id}
            ReleaseBtnClassName={styles.ReleaseBtn}
          />
        )} */}
    </div>
  );
}
